import tokens from '@lacedltd/design-tokens';

// Token helpers
function generatePadding() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return args
        .map(function (arg) {
        if (typeof arg === "string" && arg.includes("spacing.")) {
            var tokenKey = arg.replace("spacing.", "");
            return tokens.spacing[tokenKey];
        }
        return "".concat(arg);
    })
        .join(" ");
}
var generateMargin = generatePadding;
function generateBorder(width, style, 
// @ts-expect-error `${ColorKey}.${keyof Tokens["color"][ColorKey]}` throws an error, but it works in practice
// eslint-disable-next-line @typescript-eslint/ban-types
color) {
    var _a;
    var _b = color.split("."), colorKey = _b[0], colorProperty = _b[1];
    return "".concat(tokens.borderWidth[width], " ").concat(style, " ").concat(((_a = tokens.color[colorKey]) === null || _a === void 0 ? void 0 : _a[colorProperty]) || color);
}

export { generateBorder, generateMargin, generatePadding };
//# sourceMappingURL=tokens.js.map
